import { IState } from '../../store';

export const selectBuyAnalyticsLegalDocsUrlEnabled = (state: IState): boolean =>
  state.featureToggle.isLegalDocsUrlForCommercialReportsEnabled;
